import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    Card,
    CardBody,
    CardHeader
} from "../../../../_metronic/_partials/controls";
import { changeStatusTechnology, deleteTechnology, getAllTechnologies } from "../../../../api/technology";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";
import { buttonFormatterEditDisable } from "../../../components/tables/buttonFormatterTable";

function getData(technologies) { // PASARLO A MAP
    let data = []
    for (let i = 0; i < technologies.length; ++i) {
        const elem = {}
        elem.title = getNonEmpty(technologies[i].title)
        elem.description = getNonEmpty(technologies[i].description)
        elem.createdAt = technologies[i].createdAt
        elem.active = technologies[i].active
        elem.id = technologies[i]._id
        data = data.concat(elem)
    }
    return data
}

export default function TechnologyPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [technology, setTechnology] = useState(null);

    useEffect(() => {
        getAllTechnologies()
            .then((res) => {
                setData(getData(res.data));
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get technologies.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell) => buttonFormatterEditDisable(cell, "technology", data, user?.role === "admin", setTechnology, setOpenConfirmDialog, history),
            headerStyle: { width: '150px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Technologies list">
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={`Are you sure you want to ${technology?.active ? "deactivate" : "activate"} this technology?`}
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            changeStatusTechnology(technology.id, !technology?.active)
                                .then((res) => {
                                    alertSuccess({
                                        title: `${technology?.active ? "Deactivate!" : "Activate!"
                                            }`,
                                        customMessage: `Technology ${technology?.active ? "deactivate" : "activate"
                                            } successfully`,
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: `Could not ${technology?.active ? "deactivate" : "activate"
                                            } the technology.`,
                                    });
                                });
                        }}
                    />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this technology?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteTechnology(technology.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Technology deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the technology.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}